import { createContext } from 'react';
export const AuthProviderContext = createContext(null);
